export const INIT_FORM_SIGNATURE = {
  name: '',
  descripcion: '',
  formContent: '',
  emailContent: '',
  smsContent: '',
  status: 'ACTIVE',
  id: '',
}

export const tabOrder = [
  'form-settings',
  'form-notifications',
  'form-content',
  // 'form-disclaimers',
] as const

export const clientVarsByLead = {
  name: 'clientsByLead',
  label: 'Client (Lead)',
  icon: 'bi bi-person-lines-fill',
  options: [
    {key: 'client_name', label: 'Client Name'},
    {key: 'client_email', label: 'Client Email'},
    {key: 'client_phone', label: 'Client Phone'},
    {key: 'client_address', label: 'Client Address'},
    {key: 'client_city', label: 'Client City'},
    {key: 'client_state', label: 'Client State'},
    {key: 'client_zip', label: 'Client Zip'},
  ],
}

export const clientVarsByPolicy = {
  name: 'clientsByPolicy',
  label: 'Client (Policy)',
  icon: 'bi bi-person-vcard',
  options: [
    {key: 'client_address', label: 'Client Address'},
    {key: 'client_address_2', label: 'Client Address 2'},
    {key: 'client_city', label: 'Client City'},
    {key: 'client_state', label: 'Client State'},
    {key: 'client_zip', label: 'Client Zip'},
    {key: 'client_first_name', label: 'Client First Name'},
    {key: 'client_middle_name', label: 'Client Middle Name'},
    {key: 'client_last_name', label: 'Client Last Name'},
    {key: 'client_first_name_upper', label: 'Client First Name Upper'},
    {key: 'client_middle_name_upper', label: 'Client Middle Name Upper'},
    {key: 'client_last_name_upper', label: 'Client Last Name Upper'},
    {key: 'client_email', label: 'Client Email'},
    {key: 'client_phone', label: 'Client Phone'},
    {key: 'client_dob', label: 'Client Dob'},
    {key: 'client_gender', label: 'Client Gender'},
    {key: 'client_marital_status', label: 'Client Marital Status'},
    {key: 'client_ssn', label: 'Client SSN'},
    {key: 'client_preferred_language', label: 'Client Preferred Language'},
    {key: 'client_income', label: 'Client Income'},
    {key: 'client_source_of_income', label: 'Client Source of Income'},
  ],
}

export const infoPolicyVars = {
  name: 'infoPolicy',
  label: 'Policy',
  icon: 'bi bi-file-earmark-text',
  options: [
    {key: 'policy_effective_date', label: 'Policy Effective Date'},
    {key: 'policy_total_cost', label: 'Policy Total Cost'},
    {key: 'policy_premium', label: 'Policy Premium'},
    {key: 'client_name', label: 'Client Name'},
  ],
}

export const infoAgenteVars = {
  name: 'infoAgente',
  label: 'Agente',
  icon: 'bi bi-person-badge',
  options: [
    {key: 'agent_name', label: 'Agent Name'},
    {key: 'agent_email', label: 'Agent Email'},
    {key: 'agent_phone', label: 'Agent Phone'},
    {key: 'agent_npn', label: 'Agent Npn'},
  ],
}
